












































import {Component, Vue, Prop, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import {Profile} from '@/store/modules/lib'
import FilterSelect from '@/components/lfs/ShardList/filters/FilterSelect.vue';

const profile = namespace('profile')

@Component({
  components: {
    FilterSelect
  },
  name: 'c-shard-toolbar'
})
export default class ShardToolbar extends Vue {
  @Prop(Object) shards!: any

  @profile.Getter('plan') plan!: string
  @profile.Getter('profiles') profiles!: Profile[]

  filtersItem: Array<object> = [
    {
      name: 'По виду данных',
      variable: 'dhdhd',
      type: 'select',
      action: false,
      value: [1]
    },
    {
      name: 'По стендисту',
      variable: 'dhdhd',
      type: 'select',
      action: false,
      value: [1]
    },
    {
      name: 'По дате',
      variable: 'dhdhd',
      type: 'select',
      action: false,
      value: [1]
    },
    {
      name: 'Скрыть не загруженные',
      variable: 'dhdhd',
      type: 'select',
      action: false,
      value: [1]
    },
  ]

  filterState: boolean = false
  selectedFilter: any = null
  hideDeferred: boolean = false

  @Watch('hideDeferred')
  isHideDeferredChanged(newValue: boolean) {
    this.$emit('changeHideDeferred', newValue)
  }

  protected selectFilter(filter: any) {
    this.selectedFilter = filter
    this.filterState = false
    this.$emit('selectFilter', filter.id)
  }

  get shardsArray() {
    const res: any[] = []

    Object.values(this.shards).map((x: any) => {
      res.push(...x)
    })

    return res
  }

  get companies() {
    return this.shardsArray.filter((shard) => shard.target_type === 'company').length
  }

  get badges() {
    return this.shardsArray.filter((shard) => shard.target_type === 'badge').length
  }

  get products() {
    return this.shardsArray.filter((shard) => shard.target_type === 'product').length
  }

  get surveys() {
    return this.shardsArray.filter(
      (shard) => shard.surveyData.answers.length > 0
    ).length
  }

  get filterOptions() {
    const profiles = this.profiles.map((profile: Profile) => {
      return {
        name: `${profile.name.first} ${profile.name.last}`,
        id: profile._id
      }
    })
    const result = this.plan === 'pro' ? [{name: 'Все', id: ''}] : []

    result.push(...profiles)

    return result
  }

  created() {
    this.selectedFilter = this.filterOptions[0]
    this.$emit('selectFilter', this.selectedFilter.id)
  }
}
